/**
 * Whether the page runs the benchmark mode (P2.0-T4, CLIENT.md 7.34): only when `?bench=` asks for it and the page is
 * a development page (`isDevelopmentPage`, `endpoint.ts`; P1.9-T143), so a published page ignores `?bench=` and never
 * loads the benchmark's code or sets `window.gameBench`, until P2.0-T5's ADR decides GM use. The world the page plays
 * has no say: a world id comes from the page's address, and nothing a link carries may open the mode.
 *
 * @param bench The page's `?bench=` value, or null when it has none.
 * @param development Whether the page is a development page.
 * @returns True when the benchmark mode runs.
 * @example
 * benchAllowed("1", isDevelopmentPage("play.odysseytales.net", "")); // false
 * benchAllowed("1", isDevelopmentPage("192.168.10.110:3000", "")); // true
 */
export function benchAllowed(bench: string | null, development: boolean): boolean {
  return bench !== null && bench !== "" && bench !== "0" && development;
}
